import { render, staticRenderFns } from "./Task_Score.vue?vue&type=template&id=77ebba3a&scoped=true"
import script from "./Task_Score.vue?vue&type=script&lang=js"
export * from "./Task_Score.vue?vue&type=script&lang=js"
import style0 from "./Task_Score.vue?vue&type=style&index=0&id=77ebba3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ebba3a",
  null
  
)

export default component.exports